export default {
  en: {
    menu: {
      lockers: 'Lockers',
      keys: 'Keys',
      users: 'Users',
      masterkeys: 'Masterkeys',
      profile: 'Profile',
      logout: 'Logout'
    },
    lockers: {
      id: 'Id',
      lockerName: 'Locker name',
      lockerDetail: 'Locker details',
      activeAccess: 'Active access',
      lastKeyUpdate: 'Last key update',
      selectUser: 'Select user',
      save: 'Save',
      from: 'From',
      to: 'To',
      lockerId: 'Locker Id',
      name: 'Name',
      description: 'Description',
      update: 'Update locker',
      addLockerOk: 'Locker created',
      updateOk: 'Locker updated',
      users: 'Users',
      noUsers: 'No users / keys assigned',
      addKeyOk: 'Key created',
      selectRange: 'Select date range',
      addUser: 'Add User',
      keyCode: 'Keycode',
      revokeKeyOk: 'The selected key has been successfully revoked',
      revokeKeyKo: 'The selected key could not be revoked',
      deleteKeyOk: 'For the selected user, the keys were successfully deleted',
      deleteKeyKo: 'For the selected user, the keys were not deleted',
      updateLockerOk: 'Locker updated correctly',
      updateLockerKo: 'Locker not updated',
      user: 'User',
      delete: 'Delete key',
      revoke: 'Revoke key',
      edit: 'Edit locker',
      emailNotExist: 'The email that informs does not belong to any user',
      errorLockerExists: 'There is a locker with that identifier'
    },
    users: {
      id: 'Id',
      userName: 'Name',
      access: 'Access',
      firstName: 'First name',
      lastName: 'Last name',
      role: 'Role',
      email: 'Email',
      addUserOk: 'User created',
      password: 'Password',
      changePassword: 'Change password',
      enabled: 'Enabled',
      disabled: 'Disabled',
      phone: 'Phone',
      save: 'Save user',
      update: 'Update user',
      updateUserOk: 'User updated correctly',
      updateUserKo: 'User not updated',
      selectRole: 'Select role',
      admin: 'Administrator',
      owner: 'Owner',
      user: 'User',
      edit: 'Edit user'
    },
    masterkeys: {
      id: 'Id',
      name: 'Name',
      masterkeyName: 'Masterkey name',
      from: 'From',
      to: 'To',
      addMasterkeyOk: 'Masterkey created',
      enabled: 'Enabled',
      disabled: 'Disabled',
      selectUser: 'Select user',
      selectLocker: 'Select locker',
      save: 'Save',
      update: 'Update',
      revoke: 'Revoke',
      delete: 'Delete',
      updateMasterkeyOk: 'Masterkey updated correctly',
      updateMasterkeyKo: 'Masterkey not updated',
      masterkeyId: 'Masterkey Id',
      users: 'Users',
      noUsers: 'No users assigned',
      noLockers: 'No lockers assigned',
      user: 'User',
      locker: 'Locker',
      fromTo: 'From - To',
      addUser: 'Add user',
      addLocker: 'Add locker',
      edit: 'Edit masterkey',
      keyCode: 'Keycode',
      revokeMasterkeyOk: 'Masterkey has been successfully revoked',
      revokeMasterkeyKo: 'Masterkey could not be revoked',
      deleteMasterkeyOk: 'Masterkey has been successfully deleted',
      deleteMasterkeyKo: 'Masterkey could not be deleted',
      assignDeviceOk: 'Device has been successfully assigned',
      assignDeviceKo: 'Device could not be assigned',
      unAssignDeviceOk: 'Device has been successfully unassigned',
      unAssignDeviceKo: 'Device could not be unassigned'
    },
    profile: {
      profile: 'Profile'
    },
    login: {
      username: 'Username',
      password: 'Password',
      email: 'Email',
      forgotPassword: 'Forgot password?',
      resetPassword: 'Reset password',
      signIn: 'Sign in',
      reset: 'The new password was sent to your email'
    }
  },
  'en-US': {
    menu: {
      lockers: 'Lockers',
      keys: 'Keys',
      users: 'Users',
      masterkeys: 'Masterkeys',
      profile: 'Profile',
      logout: 'Logout'
    },
    lockers: {
      id: 'Id',
      lockerName: 'Locker name',
      lockerDetail: 'Locker details',
      activeAccess: 'Active access',
      lastKeyUpdate: 'Last key update',
      selectUser: 'Select user',
      save: 'Save',
      from: 'From',
      to: 'To',
      lockerId: 'Locker Id',
      name: 'Name',
      description: 'Description',
      update: 'Update locker',
      addLockerOk: 'Locker created',
      updateOk: 'Locker updated',
      users: 'Users',
      noUsers: 'No users / keys assigned',
      addKeyOk: 'Key created',
      selectRange: 'Select date range',
      addUser: 'Add User',
      keyCode: 'Keycode',
      revokeKeyOk: 'The selected key has been successfully revoked',
      revokeKeyKo: 'The selected key could not be revoked',
      deleteKeyOk: 'For the selected user, the keys were successfully deleted',
      deleteKeyKo: 'For the selected user, the keys were not deleted',
      updateLockerOk: 'Locker updated correctly',
      updateLockerKo: 'Locker not updated',
      user: 'User',
      delete: 'Delete key',
      revoke: 'Revoke key',
      edit: 'Edit locker',
      emailNotExist: 'The email that informs does not belong to any user',
      errorLockerExists: 'There is a locker with that identifier'
    },
    users: {
      id: 'Id',
      userName: 'Name',
      access: 'Access',
      firstName: 'First name',
      lastName: 'Last name',
      role: 'Role',
      email: 'Email',
      addUserOk: 'User created',
      password: 'Password',
      changePassword: 'Change password',
      enabled: 'Enabled',
      disabled: 'Disabled',
      phone: 'Phone',
      save: 'Save user',
      update: 'Update user',
      updateUserOk: 'User updated correctly',
      updateUserKo: 'User not updated',
      selectRole: 'Select role',
      admin: 'Administrator',
      owner: 'Owner',
      user: 'User',
      edit: 'Edit user'
    },
    masterkeys: {
      id: 'Id',
      name: 'Name',
      masterkeyName: 'Masterkey name',
      from: 'From',
      to: 'To',
      addMasterkeyOk: 'Masterkey created',
      enabled: 'Enabled',
      disabled: 'Disabled',
      selectUser: 'Select user',
      selectLocker: 'Select locker',
      save: 'Save',
      update: 'Update',
      revoke: 'Revoke',
      delete: 'Delete',
      updateMasterkeyOk: 'Masterkey updated correctly',
      updateMasterkeyKo: 'Masterkey not updated',
      masterkeyId: 'Masterkey Id',
      users: 'Users',
      noUsers: 'No users assigned',
      noLockers: 'No lockers assigned',
      user: 'User',
      locker: 'Locker',
      fromTo: 'From - To',
      addUser: 'Add user',
      addLocker: 'Add locker',
      edit: 'Edit masterkey',
      keyCode: 'Keycode',
      revokeMasterkeyOk: 'Masterkey has been successfully revoked',
      revokeMasterkeyKo: 'Masterkey could not be revoked',
      deleteMasterkeyOk: 'Masterkey has been successfully deleted',
      deleteMasterkeyKo: 'Masterkey could not be deleted',
      assignDeviceOk: 'Device has been successfully assigned',
      assignDeviceKo: 'Device could not be assigned',
      unAssignDeviceOk: 'Device has been successfully unassigned',
      unAssignDeviceKo: 'Device could not be unassigned'
    },
    profile: {
      profile: 'Profile'
    },
    login: {
      username: 'Username',
      password: 'Password',
      email: 'Email',
      forgotPassword: 'Forgot password?',
      resetPassword: 'Reset password',
      signIn: 'Sign in',
      reset: 'The new password was sent to your email'
    }
  },
  'en-GB': {
    menu: {
      lockers: 'Lockers',
      keys: 'Keys',
      users: 'Users',
      masterkeys: 'Masterkeys',
      profile: 'Profile',
      logout: 'Logout'
    },
    lockers: {
      id: 'Id',
      lockerName: 'Locker name',
      lockerDetail: 'Locker details',
      activeAccess: 'Active access',
      lastKeyUpdate: 'Last key update',
      selectUser: 'Select user',
      save: 'Save',
      from: 'From',
      to: 'To',
      lockerId: 'Locker Id',
      name: 'Name',
      description: 'Description',
      update: 'Update locker',
      addLockerOk: 'Locker created',
      updateOk: 'Locker updated',
      users: 'Users',
      noUsers: 'No users / keys assigned',
      addKeyOk: 'Key created',
      selectRange: 'Select date range',
      addUser: 'Add User',
      keyCode: 'Keycode',
      revokeKeyOk: 'The selected key has been successfully revoked',
      revokeKeyKo: 'The selected key could not be revoked',
      deleteKeyOk: 'For the selected user, the keys were successfully deleted',
      deleteKeyKo: 'For the selected user, the keys were not deleted',
      updateLockerOk: 'Locker updated correctly',
      updateLockerKo: 'Locker not updated',
      user: 'User',
      delete: 'Delete key',
      revoke: 'Revoke key',
      edit: 'Edit locker',
      emailNotExist: 'The email that informs does not belong to any user',
      errorLockerExists: 'There is a locker with that identifier'
    },
    users: {
      id: 'Id',
      userName: 'Name',
      access: 'Access',
      firstName: 'First name',
      lastName: 'Last name',
      role: 'Role',
      email: 'Email',
      addUserOk: 'User created',
      password: 'Password',
      changePassword: 'Change password',
      enabled: 'Enabled',
      disabled: 'Disabled',
      phone: 'Phone',
      save: 'Save user',
      update: 'Update user',
      updateUserOk: 'User updated correctly',
      updateUserKo: 'User not updated',
      selectRole: 'Select role',
      admin: 'Administrator',
      owner: 'Owner',
      user: 'User',
      edit: 'Edit user'
    },
    masterkeys: {
      id: 'Id',
      name: 'Name',
      masterkeyName: 'Masterkey name',
      from: 'From',
      to: 'To',
      addMasterkeyOk: 'Masterkey created',
      enabled: 'Enabled',
      disabled: 'Disabled',
      selectUser: 'Select user',
      selectLocker: 'Select locker',
      save: 'Save',
      update: 'Update',
      revoke: 'Revoke',
      delete: 'Delete',
      updateMasterkeyOk: 'Masterkey updated correctly',
      updateMasterkeyKo: 'Masterkey not updated',
      masterkeyId: 'Masterkey Id',
      users: 'Users',
      noUsers: 'No users assigned',
      noLockers: 'No lockers assigned',
      user: 'User',
      locker: 'Locker',
      fromTo: 'From - To',
      addUser: 'Add user',
      addLocker: 'Add locker',
      edit: 'Edit masterkey',
      keyCode: 'Keycode',
      revokeMasterkeyOk: 'Masterkey has been successfully revoked',
      revokeMasterkeyKo: 'Masterkey could not be revoked',
      deleteMasterkeyOk: 'Masterkey has been successfully deleted',
      deleteMasterkeyKo: 'Masterkey could not be deleted',
      assignDeviceOk: 'Device has been successfully assigned',
      assignDeviceKo: 'Device could not be assigned',
      unAssignDeviceOk: 'Device has been successfully unassigned',
      unAssignDeviceKo: 'Device could not be unassigned'
    },
    profile: {
      profile: 'Profile'
    },
    login: {
      username: 'Username',
      password: 'Password',
      email: 'Email',
      forgotPassword: 'Forgot password?',
      resetPassword: 'Reset password',
      signIn: 'Sign in',
      reset: 'The new password was sent to your email'
    }
  },
  es: {
    menu: {
      lockers: 'Lockers',
      keys: 'Keys',
      users: 'Users',
      masterkeys: 'Masterkeys',
      profile: 'Profile',
      logout: 'Logout'
    },
    lockers: {
      id: 'Id',
      lockerName: 'Locker name',
      lockerDetail: 'Locker details',
      activeAccess: 'Active access',
      lastKeyUpdate: 'Last key update',
      selectUser: 'Select user',
      save: 'Save',
      from: 'From',
      to: 'To',
      lockerId: 'Locker Id',
      name: 'Name',
      description: 'Description',
      update: 'Update locker',
      addLockerOk: 'Locker created',
      updateOk: 'Locker updated',
      users: 'Users',
      noUsers: 'No users / keys assigned',
      addKeyOk: 'Key created',
      selectRange: 'Select date range',
      addUser: 'Add User',
      keyCode: 'Keycode',
      revokeKeyOk: 'The selected key has been successfully revoked',
      revokeKeyKo: 'The selected key could not be revoked',
      deleteKeyOk: 'For the selected user, the keys were successfully deleted',
      deleteKeyKo: 'For the selected user, the keys were not deleted',
      updateLockerOk: 'Locker updated correctly',
      updateLockerKo: 'Locker not updated',
      user: 'User',
      delete: 'Delete key',
      revoke: 'Revoke key',
      edit: 'Edit locker',
      emailNotExist: 'The email that informs does not belong to any user',
      errorLockerExists: 'There is a locker with that identifier'
    },
    users: {
      id: 'Id',
      userName: 'Name',
      access: 'Access',
      firstName: 'First name',
      lastName: 'Last name',
      role: 'Role',
      email: 'Email',
      addUserOk: 'User created',
      password: 'Password',
      changePassword: 'Change password',
      enabled: 'Enabled',
      disabled: 'Disabled',
      phone: 'Phone',
      save: 'Save user',
      update: 'Update user',
      updateUserOk: 'User updated correctly',
      updateUserKo: 'User not updated',
      selectRole: 'Select role',
      admin: 'Administrator',
      owner: 'Owner',
      user: 'User',
      edit: 'Edit user'
    },
    masterkeys: {
      id: 'Id',
      name: 'Name',
      masterkeyName: 'Masterkey name',
      from: 'From',
      to: 'To',
      addMasterkeyOk: 'Masterkey created',
      enabled: 'Enabled',
      disabled: 'Disabled',
      selectUser: 'Select user',
      selectLocker: 'Select locker',
      save: 'Save',
      update: 'Update',
      revoke: 'Revoke',
      delete: 'Delete',
      updateMasterkeyOk: 'Masterkey updated correctly',
      updateMasterkeyKo: 'Masterkey not updated',
      masterkeyId: 'Masterkey Id',
      users: 'Users',
      noUsers: 'No users assigned',
      noLockers: 'No lockers assigned',
      user: 'User',
      locker: 'Locker',
      fromTo: 'From - To',
      addUser: 'Add user',
      addLocker: 'Add locker',
      edit: 'Edit masterkey',
      keyCode: 'Keycode',
      revokeMasterkeyOk: 'Masterkey has been successfully revoked',
      revokeMasterkeyKo: 'Masterkey could not be revoked',
      deleteMasterkeyOk: 'Masterkey has been successfully deleted',
      deleteMasterkeyKo: 'Masterkey could not be deleted',
      assignDeviceOk: 'Device has been successfully assigned',
      assignDeviceKo: 'Device could not be assigned',
      unAssignDeviceOk: 'Device has been successfully unassigned',
      unAssignDeviceKo: 'Device could not be unassigned'
    },
    profile: {
      profile: 'Profile'
    },
    login: {
      username: 'Username',
      password: 'Password',
      email: 'Email',
      forgotPassword: 'Forgot password?',
      resetPassword: 'Reset password',
      signIn: 'Sign in',
      reset: 'The new password was sent to your email'
    }
  },
  'es-ES': {
    menu: {
      lockers: 'Lockers',
      keys: 'Keys',
      users: 'Users',
      masterkeys: 'Masterkeys',
      profile: 'Profile',
      logout: 'Logout'
    },
    lockers: {
      id: 'Id',
      lockerName: 'Locker name',
      lockerDetail: 'Locker details',
      activeAccess: 'Active access',
      lastKeyUpdate: 'Last key update',
      selectUser: 'Select user',
      save: 'Save',
      from: 'From',
      to: 'To',
      lockerId: 'Locker Id',
      name: 'Name',
      description: 'Description',
      update: 'Update locker',
      addLockerOk: 'Locker created',
      updateOk: 'Locker updated',
      users: 'Users',
      noUsers: 'No users / keys assigned',
      addKeyOk: 'Key created',
      selectRange: 'Select date range',
      addUser: 'Add User',
      keyCode: 'Keycode',
      revokeKeyOk: 'The selected key has been successfully revoked',
      revokeKeyKo: 'The selected key could not be revoked',
      deleteKeyOk: 'For the selected user, the keys were successfully deleted',
      deleteKeyKo: 'For the selected user, the keys were not deleted',
      updateLockerOk: 'Locker updated correctly',
      updateLockerKo: 'Locker not updated',
      user: 'User',
      delete: 'Delete key',
      revoke: 'Revoke key',
      edit: 'Edit locker',
      emailNotExist: 'The email that informs does not belong to any user',
      errorLockerExists: 'There is a locker with that identifier'
    },
    users: {
      id: 'Id',
      userName: 'Name',
      access: 'Access',
      firstName: 'First name',
      lastName: 'Last name',
      role: 'Role',
      email: 'Email',
      addUserOk: 'User created',
      password: 'Password',
      changePassword: 'Change password',
      enabled: 'Enabled',
      disabled: 'Disabled',
      phone: 'Phone',
      save: 'Save user',
      update: 'Update user',
      updateUserOk: 'User updated correctly',
      updateUserKo: 'User not updated',
      selectRole: 'Select role',
      admin: 'Administrator',
      owner: 'Owner',
      user: 'User',
      edit: 'Edit user'
    },
    masterkeys: {
      id: 'Id',
      name: 'Name',
      masterkeyName: 'Masterkey name',
      from: 'From',
      to: 'To',
      addMasterkeyOk: 'Masterkey created',
      enabled: 'Enabled',
      disabled: 'Disabled',
      selectUser: 'Select user',
      selectLocker: 'Select locker',
      save: 'Save',
      update: 'Update',
      revoke: 'Revoke',
      delete: 'Delete',
      updateMasterkeyOk: 'Masterkey updated correctly',
      updateMasterkeyKo: 'Masterkey not updated',
      masterkeyId: 'Masterkey Id',
      users: 'Users',
      noUsers: 'No users assigned',
      noLockers: 'No lockers assigned',
      user: 'User',
      locker: 'Locker',
      fromTo: 'From - To',
      addUser: 'Add user',
      addLocker: 'Add locker',
      edit: 'Edit masterkey',
      keyCode: 'Keycode',
      revokeMasterkeyOk: 'Masterkey has been successfully revoked',
      revokeMasterkeyKo: 'Masterkey could not be revoked',
      deleteMasterkeyOk: 'Masterkey has been successfully deleted',
      deleteMasterkeyKo: 'Masterkey could not be deleted',
      assignDeviceOk: 'Device has been successfully assigned',
      assignDeviceKo: 'Device could not be assigned',
      unAssignDeviceOk: 'Device has been successfully unassigned',
      unAssignDeviceKo: 'Device could not be unassigned'
    },
    profile: {
      profile: 'Profile'
    },
    login: {
      username: 'Username',
      password: 'Password',
      email: 'Email',
      forgotPassword: 'Forgot password?',
      resetPassword: 'Reset password',
      signIn: 'Sign in',
      reset: 'The new password was sent to your email'
    }
  }
};



// WEBPACK FOOTER //
// ./src/javascripts/lib/intl/messages.js